<template>
  <div v-if="pageLoading" class="text-center mt-5 w-100">
    <div class="spinner-border" role="status"></div>
  </div>
  <template v-else-if="pageError">
    <NotFound />
  </template>
  <div v-else class="search-view-wrapper">
    <NavbarView :data="brandData" :apiUrlStorage="apiUrlStorage"></NavbarView>
    <div class="search-page">
    <div class="search-card">

      <!-- Header -->
      <div class="card-header">
        <h1 class="search-title">
          Upgrade your Flight! Sind Sie bereit für Ihren Urlaub? Verwalten Sie Ihren Flug hier:
        </h1>
        <!-- <button class="lang-btn">
          <span class="flag">🇩🇪</span>
          <span>DE</span>
          <span class="chevron">&#8964;</span>
        </button> -->
      </div>

      <!-- Features -->
      <div class="tabs-row d-none d-md-flex">
        <span
          v-for="tab in tabs"
          :key="tab.id"
          class="tab-btn"
        >{{ tab.label }}</span>
      </div>

      <!-- Inputs -->
      <div class="row g-3 mb-3">
        <div class="col-12 col-md-6">
          <div class="floating-input">
            <label class="float-label">Nachname</label>
            <input type="text" v-model="lastName" class="float-field" />
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="floating-input">
            <label class="float-label">Buchungscode oder Vorgangsnummer</label>
            <input type="text" v-model="bookingNumber" class="float-field" />
          </div>
          <small
            class="d-block text-muted mt-2 help-tooltip"
            :data-tooltip="bookingCodeHelpText"
          >Wo kann ich meinen Buchungscode finden?</small>
        </div>

      </div>

         <!-- Error -->
      <div v-if="error" class="search-error">{{ error }}</div>
      <!-- Button -->
      <div class="button-row">
        <button class="submit-btn" @click="search" :disabled="loading">
          <span v-if="loading" class="btn-loading-overlay">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </span>
          <span :style="loading ? 'visibility: hidden' : ''">Flug aufrufen</span>
        </button>
      </div>

      <!-- Footer Text -->
      <div class="footer-text">
        <p>
          <strong>Sie fliegen nicht mit TUI fly?</strong><br>
          Auf ausgewählten Flügen mit Smartlynx Airlines, Enter Air, Aegen Airlines, Bulgarian Air Charter, Freebird Europe, Alba Star, SkyUp MT können Sie sich mit Ihrer Buchungsnummer und Namen einloggen und Sitzplatzreservierungen tätigen oder Gepäck hinzubuchen.<br>
          Abhängig davon, mit welcher Fluggesellschaft Sie fliegen, gelten unterschiedliche Bedingungen für den Web Check-in, für die Web Check-in Zeiten sowie für die Kosten für den Check-in am Flughafenschalter.
           Für ausgewählte Fluggesellschaften finden Sie ausführliche Infos hier oder auf der Webseite der jeweiligen Fluggesellschaft.
        </p>
      </div>

    </div>
  </div>
  <FooterViewD class="d-none d-md-block" :data="brandData" :apiUrlStorage="apiUrlStorage" :signature="signature" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NotFound from '@/components/errors/NotFound.vue';
import NavbarView from '@/components/NavbarView.vue';
import FooterViewD from '@/components/desktop/FooterView.vue';

export default {
  components: { NotFound, NavbarView, FooterViewD },
  data() {
    return {
      brandData: null,
      pageError: false,
      bookingNumber: '',
      bookingCodeHelpText: 'Um Ihre Buchungsdetails abzurufen, nutzen Sie bitte Ihren 6‑stelligen PNR‑Buchungscode (z. B. KU6NLX). Ihre PNR- Buchungscode finden Sie in Ihrer TUI‑Bestätigungsmail oder in Ihrem myTUI‑Onlinekonto. Verwenden Sie nicht ihre Flugnummer z. B. EK123, da dieser nicht für die Anmeldung geeignet ist. Sollten Sie Ihren PNR-Buchungscode nicht finden, überprüfen Sie bitte die Bestätigungs‑E-Mail samt Ihrem Reiseplan oder kontaktieren Sie TUI direkt für Unterstützung.',
      lastName: '',
      error: null,
      loading: false,
      pageLoading: true,
      tabs: [
        { id: '1', label: 'Sitzplätze\nauswählen' },
      ],
    };
  },
  async mounted() {
    const subdomain = window.location.hostname.split('.')[0];
    const env = process.env.VUE_APP_ENV;
    if (subdomain !== 'tui' && env === 'prod') {
      this.pageError = true;
      this.pageLoading = false;
      return;
    }

    try {
      const { data } = await window.axios.get(process.env.VUE_APP_API_V2_URL + 'ancillaries/post-sale-session/get-brand');
      this.brandData = data;
      document.title = data.brand.whitelabel_config.tabTitle;
      const favicon = document.getElementById('favicon');
      favicon.href = this.apiUrlStorage + data.brand.whitelabel_config.favicon;
    } catch {
      this.pageError = true;
    } finally {
      this.pageLoading = false;
    }
  },
  computed: {
    ...mapState(['apiUrlStorage', 'signature']),
  },
  methods: {
    async search() {
      if (!this.bookingNumber || !this.lastName) {
        this.error = 'Bitte Buchungsnummer und Nachname eingeben.';
        return;
      }
      const url = process.env.VUE_APP_API_V2_URL + `ancillaries/post-sale-session/${encodeURIComponent(this.bookingNumber)}/${encodeURIComponent(this.lastName)}/json`;
      this.loading = true;
      try {
        const { data } = await window.axios.get(url);
        window.location.href = data.data.url;
      } catch (error) {
        this.error = 'Buchung nicht gefunden.';
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.search-view-wrapper :deep(footer.whitelabel-footer) {
  margin-top: 0;
}

@font-face {
  font-family: "tui-type";
  src: url("https://cloud.tui.com/ui/ui-assets/v1/fonts/tuitypelight-regular.woff2") format("woff2"),
       url("https://cloud.tui.com/ui/ui-assets/v1/fonts/tuitypelight-regular.woff") format("woff");
  font-display: swap;
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "tui-type";
  src: url("https://cloud.tui.com/ui/ui-assets/v1/fonts/tuitypelight-bold.woff2") format("woff2"),
       url("https://cloud.tui.com/ui/ui-assets/v1/fonts/tuitypelight-bold.woff") format("woff");
  font-display: swap;
  font-weight: 700;
  font-style: normal;
}

/* ── Page wrapper ── */
.search-page {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-height: calc(80vh - 96px);
  width: 100%;
  background-image: url('@/assets/images/tui/search-background.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 60px 120px;
  box-sizing: border-box;
}

/* ── Card ── */
.search-card {
  width: 680px;
  font-family: "tui-type", sans-serif;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  padding: 20px;
  border-radius: 6px;
  box-sizing: border-box;
}

/* ── Mobile ── */
@media (max-width: 768px) {
  .search-page {
    padding: 20px 16px;
    align-items: flex-start;
    min-height: 100vh;
  }

  .search-card {
    width: 100%;
  }

  .tabs-row {
    display: none;
  }

.submit-btn {
    width: 100%;
  }

  .button-row {
    justify-content: stretch;
  }
}

/* ── Header ── */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 28px;
}

.search-title {
  font-family: "TUITypeLight", tuitypelightregular, "tui-type", arial, sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #092a5e;
  line-height: 1.25;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  max-width: 76%;
}

.lang-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 500;
  color: #002d5f;
  background: none;
  border: 1px solid #c8d0da;
  border-radius: 3px;
  cursor: pointer;
  padding: 5px 10px;
  margin-top: 4px;
  transition: background 0.15s;
}

.lang-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}

.chevron {
  font-size: 14px;
  line-height: 1;
  color: #555;
}

/* ── Tabs ── */
.tabs-row {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 20px;
}

.tab-btn {
  flex: 1;
  text-align: left;
  font-family: "tuitype", "tui-type", arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
  padding: 0 6px 10px;
  background: none;
  border: none;
  color: #092a5e;
  opacity: 0.75;
  transition: opacity 0.15s;
  white-space: pre-line;
}

/* ── Inputs ── */
.floating-input {
  position: relative;
}

.float-label {
  position: absolute;
  top: 5px;
  left: 10px;
  z-index: 10;
  font-family: "tuitype", "tui-type", arial, sans-serif;
  font-size: 15px;
  font-weight: normal;
  line-height: 1.333;
  color: #333;
  pointer-events: none;
}

.float-field {
  width: 100%;
  height: 54px;
  padding: 24px 12px 6px;
  border: 1px solid #c8d0da;
  background: #fff;
  color: #002d5f;
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
  border-radius: 2px;
}

.float-field:focus {
  border-color: #002d5f;
}

/* ── Button ── */
.button-row {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 26px;
}

.submit-btn {
  display: inline-block;
  position: relative;
  margin: 0;
  padding: 10px;
  font-family: "tuitype", "tui-type", arial, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  color: white;
  background-color: #d40e14;
  border-style: solid;
  border-width: 0.1rem;
  border-color: #092a5e;
  border-radius: 0.3rem;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.1s ease 0s;
}

.submit-btn:hover {
  background-color: #b31c22;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}


/* ── Error ── */
.search-error {
  color: #d40e14;
  font-size: 1.4rem;
  margin-bottom: 12px;
}

/* ── Help Tooltip ── */
.help-tooltip {
  display: inline-block;
  position: relative;
  cursor: pointer;
  text-decoration: none;
}

.help-tooltip::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #86CAF0;
  color: #092a5e;
  padding: 12px 14px;
  border-radius: 6px;
  font-size: 13px;
  white-space: normal;
  overflow-wrap: break-word;
  width: clamp(280px, 52vw, 520px);
  max-width: calc(100vw - 32px);
  z-index: 1000;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  line-height: 1.5;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.help-tooltip:hover::before {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 768px) {
  .help-tooltip::before {
    left: -20px;
    transform: none;
    width: min(520px, calc(100vw - 32px));
  }
}

/* ── Footer Text ── */
.footer-text p {
  font-family: "tuitype", "tui-type", arial, sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #4c4c4c;
  line-height: 1.3;
  text-align: left;
  padding: 0;
  margin: 0;
}
</style>
